export default "__VITE_ASSET__26e90af8__"